import React from 'react'

export default function Footer() {
  return (
    <>
    {/* =========================
 FOOTER
========================== */}
  <footer className="footer">
    <div className="container">
      <div className="footer-grid">
        {/* About */}
        <div className="footer-about">
          <h3>Gandhi Mandela Foundation</h3>
          <p style={{textAlign: 'justify'}}>
            The Gandhi Mandela Foundation (GMF) is a Government of India–recognized trust, established to promote the timeless values, ideals, and principles of Mahatma Gandhi and Nelson Mandela, fostering global peace, non-violence, individual freedom, civil liberties, and human rights.
          </p>
          <div className="social-icons">
            <a href="https://www.facebook.com/gandhimandelafoundation" target="_blank"><i className="fa-brands fa-facebook-f" /></a>
            <a href="https://www.instagram.com/gandhimandelafoundation/" target="_blank"><i className="fa-brands fa-instagram" /></a>
            <a href="https://x.com/GandhiMandelaHQ" target="_blank"><i className="fa-brands fa-x-twitter" /></a>
            <a href="https://www.linkedin.com/company/gandhimandelafoundation" target="_blank"><i className="fa-brands fa-linkedin-in" /></a>
          </div>
        </div>
        {/* Links */}
        <div className="footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about-gmf">About GMF</a></li>
            <li><a href="/gallery">Gallery</a></li>
            <li><a href="/news-media">Latest News</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
        {/* Contact */}
        <div className="footer-contact">
          <h3>Contact Us</h3>
          <ul>
            <li>
              <i className="fa-solid fa-phone" />
              <a href="tel:+91 11 3530 1996">
                +91 11 3530 1996
              </a>
            </li>
            <li>
              <i className="fa-solid fa-envelope" />
              <a href="mailto:info@gandhimandelafoundation.com">
                info@gandhimandelafoundation.com
              </a>
            </li>
            <li>
              <i className="fa-solid fa-location-dot" />
              <span>511, Naurang House, K.G. Marg, New Delhi - 110001, India</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© Gandhi Mandela Foundation. All Rights Reserved.</p>
        {/*<p>
          Designed & Developed by
          <a href="#">Your Company</a>
      </p>*/}
      </div>
    </div>
  </footer>
    </>
  )
}
